import React from "react";

// react-bootstrap components
import {
  Badge,
  Button,
  Card,
  Form,
  InputGroup,
  Navbar,
  Modal,
  Table,
  Container,
  Row,
  Col,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";

import {
  getShift,
  daftarShift,
  deleteShift,
  getAreaNonGroup,
  assignRoomToShift,
  getPatrol,
  editWaktuPatrol,
  addWaktuPatrol,
} from "../../../stores";
import { useDispatch, useSelector } from "react-redux";
import TagsInput from "components/TagsInput/TagsInput.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import Select from "react-select";
import Swal from "sweetalert2";

function RegularTables() {
  const dispatch = useDispatch();
  const [modal, setModal] = React.useState(false);

  const [durasi, setDurasi] = React.useState("");
  const monitoring = useSelector((state) => state.monitoringReducer);
  const [jamStr, setJamStr] = React.useState([]);
  const [shiftAssign, setShiftAssign] = React.useState(null);
  const [ruangan, setRuangan] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [dataPatrol, setDataPatrol] = React.useState([]);
  const [tampilModal, setTampilModal] = React.useState("");
  const [jamShift, setJamShift] = React.useState("");
  const [jamMulai, setJamMulai] = React.useState("");
  const [jamSelesai, setJamSelesai] = React.useState("");
  const [kunjunganKe, setKunjunganKe] = React.useState("");
  const [batasJam, setBatasJam] = React.useState("");
  const [jenisHari, setJenisHari] = React.useState("");
  const [idShift, setIdShift] = React.useState(null);

  React.useEffect(() => {
    let tmp = monitoring.jamPatroli.map((val) => {
      let listJam = val.shift?.[0]?.jam;

      return {
        ...val,
        namaShift:
          val.jamShift === 15
            ? "Shift 1"
            : val.jamShift === 23
            ? "Shift 2"
            : val.jamShift === 7
            ? "Shift 3"
            : "Shift Not Registered ",
        jamShift: String(val.jamShift).padStart(2, "0") + ":00",
        jamMulai: String(val.jamMulai).padStart(2, "0") + ":00",
        jamSelesai: String(val.jamSelesai).padStart(2, "0") + ":00",
        jenisHari:
          val.jenisHari === "biasa"
            ? "Hari Biasa"
            : val.jenisHari === "libur"
            ? "Hari Libur"
            : val.jenisHari,
        status: val.aktif ? "Yes" : "No",
        actions: (
          <div className="actions-right">
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip>Edit Setting Patrol</Tooltip>}
            >
              <Button
                onClick={() => {
                  setDataPatrol(val);
                  setModal(true);
                  setTampilModal("edit");
                  setIdShift(val.shift[0]?._id || null);
                  setJamShift(val.jamShift);
                  setJamMulai(val.jamMulai);
                  setJamSelesai(val.jamSelesai);
                  setKunjunganKe(val.kunjunganKe);
                  setBatasJam(val.batasWaktu);
                  setJenisHari(val.jenisHari);
                }}
                variant="link"
                className="p-0 border-0 shadow-none"
                style={{ textDecoration: "none" }}
              >
                <i
                  className="fas fa-edit fa-lg"
                  style={{
                    color: "#ff8000",
                  }}
                />
              </Button>
            </OverlayTrigger>
          </div>
        ),
      };
    });

    setData(tmp);
  }, [monitoring.jamPatroli]);

  function editSkemaPatrol(e) {
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
    editWaktuPatrol({
      idPatrol: dataPatrol._id,
      idShift: idShift,
      jamShift: jamShift,
      jamMulai: jamMulai,
      jamSelesai: jamSelesai,
      kunjunganKe: kunjunganKe,
      batasJam: batasJam,
      jenisHari: jenisHari,
    }).then((response) => {
      if (response.status === 200) {
        window.location.reload();
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
      } else if (response.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      }
    });
  }

  const createWaktuPatrol = () => {
    if (
      idShift === null ||
      jamShift === "" ||
      jamMulai === "" ||
      jamSelesai === "" ||
      kunjunganKe === "" ||
      batasJam === "" ||
      jenisHari === ""
    ) {
      return Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Semua field harus diisi!",
      });
    }
    Swal.fire({
      title: "Loading...",
      allowOutsideClick: false,
      showConfirmButton: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });

    addWaktuPatrol({
      idShift: idShift,
      jamShift: jamShift,
      jamMulai: jamMulai,
      jamSelesai: jamSelesai,
      kunjunganKe: kunjunganKe,
      batasJam: batasJam,
      jenisHari: jenisHari,
    }).then((response) => {
      if (response.status === 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 1500,
        });
        window.location.reload();
        getSidak(dispatch);
        setModalSidak(false);
      } else if (response.status === 400) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: response.data.message,
        });
      }
    });
  };

  const shiftOptions = monitoring.jamLaporan.flatMap((val) =>
    val.jam.map((jam, index) => ({
      id: val._id,
      value: jam,
      label: `Shift ${index + 1} (${String(jam).padStart(2, "0")}:00)`,
    }))
  );
  const selectedShift =
    shiftOptions.find((opt) => opt.value === jamShift) || null;

  const tipeHari = [
    { value: "biasa", label: "Hari Biasa" },
    { value: "libur", label: "Hari Libur" },
  ];
  const selectedJenisHari =
    tipeHari.find((opt) => opt.value === jenisHari) || null;

  // React.useEffect(() => {
  //   if (tampilModal === "edit" && dataPatrol?.jamMulai !== undefined) {
  //     setJamMulai(dataPatrol.jamMulai);
  //   }
  // }, [tampilModal, dataPatrol]);
  // React.useEffect(() => {
  //   let tmp = [...monitoring.listArea];
  //   tmp.forEach((val) => {
  //     val.ruangan.forEach((val2) => {
  //       val2.check = false;
  //     });
  //   });
  //   setRuangan(tmp);
  // }, [monitoring.listArea]);

  // React.useEffect(() => {
  //   if (shiftAssign) {
  //     let tmp = [...monitoring.listArea];
  //     tmp.forEach((val) => {
  //       val.ruangan.forEach((val2) => {
  //         if (shiftAssign.id === val2.idShift) {
  //           val2.check = true;
  //         } else {
  //           val2.check = false;
  //         }
  //       });
  //     });
  //     setRuangan(tmp);
  //   }
  // }, [shiftAssign]);
  React.useEffect(() => {
    getShift(dispatch);
    getPatrol(dispatch);
    getAreaNonGroup(dispatch);
  }, []);
  return (
    <>
      <Container fluid>
        <Row>
          <Col>
            <Button
              className="btn-wd mr-1"
              onClick={() => {
                setModal(true);
                setTampilModal("add");
                setModal(true);
                setIdShift(null);
                setJamShift("");
                setJamMulai("");
                setJamSelesai("");
                setKunjunganKe("");
                setBatasJam("");
                setJenisHari("");
              }}
              variant="primary"
            >
              Add Patrol
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md={shiftAssign ? "4" : "12"}>
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Patrol Monitoring</Card.Title>
              </Card.Header>
              <Card.Body className="table-responsive p-0">
                <Card.Body>
                  <ReactTable
                    data={data}
                    // showPagination={false}
                    columns={[
                      {
                        Header: "Shift Name",
                        accessor: "namaShift",
                      },
                      // {
                      //   Header: "Finishing Time Shift",
                      //   accessor: "jamShift",
                      // },
                      // {
                      //   Header: "Finishing Time Shift",
                      //   accessor: "jamShift",
                      // },
                      {
                        Header: "Start Time Visiting",
                        accessor: "jamMulai",
                      },
                      {
                        Header: "End Time Visiting",
                        accessor: "jamSelesai",
                      },
                      {
                        Header: "Visiting",
                        accessor: "kunjunganKe",
                      },
                      {
                        Header: "Type Of Day",
                        accessor: "jenisHari",
                      },
                      {
                        Header: "Active",
                        accessor: "status",
                      },

                      {
                        Header: "Actions",
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                      },
                    ]}
                    // className="-striped -highlight "
                  />
                </Card.Body>
                {/* <Table className="table-hover table-striped w-full">
                  <thead>
                    <tr>
                      <th>No.</th>
                      <th>Shift</th>
                      <th>End Shift Time</th>
                      <th>Visiting Time</th>
                      <th>Start Time</th>
                      <th>End Time</th>
                      <th>Type Date</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {monitoring.jamPatroli.map((val, index) => {
                      console.log(val, "AAAAA");

                      return (
                        <tr>
                          <td>{index + 1}</td>
                          <td>{val.jam + ""}</td>
                          <td>{val.durasi}</td>
                          <td>
                            <Button
                              onClick={() => {
                                setShiftAssign({ jam: val.jam, id: val._id });
                              }}
                              variant="danger"
                              size="sm"
                              className="btn-link remove text-success"
                            >
                              <i className="fa fa-check" />
                            </Button>
                            <Button
                              onClick={() => {
                                deleteShift(val._id);
                              }}
                              variant="danger"
                              size="sm"
                              className="btn-link remove text-danger"
                            >
                              <i className="fa fa-times" />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table> */}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <Modal
        size="lg"
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title id="example-modal-sizes-title-lg">
            Large Modal
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md="12">
              <Card className="stacked-form">
                <Card.Header>
                  <Card.Title as="h4">
                    {tampilModal === "add"
                      ? "Add Patrol Schema"
                      : "Edit Patrol Schema"}
                  </Card.Title>
                </Card.Header>
                <Card.Body>
                  <Form action="#" method="#">
                    <Form.Group>
                      <label>Select Shift</label>
                      <Select
                        options={shiftOptions}
                        value={selectedShift}
                        onChange={(selected) => {
                          setJamShift(selected.value); // tetap number
                          setIdShift(selected.id);
                        }}
                      />
                    </Form.Group>
                    <Form.Group>
                      <label>Start Time Visiting</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="time"
                        step="3600"
                        value={
                          jamMulai !== ""
                            ? `${String(jamMulai).padStart(2, "0")}:00`
                            : ""
                        }
                        onChange={(e) => {
                          const hour = e.target.value.split(":")[0];
                          setJamMulai(Number(hour));
                        }}
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label>End Time Visiting</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="time"
                        step="3600"
                        value={
                          jamSelesai !== ""
                            ? `${String(jamSelesai).padStart(2, "0")}:00`
                            : ""
                        }
                        onChange={(e) => {
                          const hour = e.target.value.split(":")[0];
                          setJamSelesai(Number(hour));
                        }}
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label>Visiting</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="number"
                        value={kunjunganKe !== "" ? kunjunganKe : ""}
                        onChange={(e) => {
                          setKunjunganKe(e.target.value);
                        }}
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group>
                      <label>Type of Day</label>
                      <Select
                        options={tipeHari}
                        value={selectedJenisHari}
                        onChange={(selected) => {
                          setJenisHari(selected.value);
                        }}
                      ></Select>
                    </Form.Group>
                    <Form.Group>
                      <label>Time end</label>
                      <Form.Control
                        // placeholder="Durasi pengerjaan"
                        type="time"
                        step="3600"
                        value={
                          batasJam !== ""
                            ? `${String(batasJam).padStart(2, "0")}:00`
                            : ""
                        }
                        onChange={(e) => {
                          const hour = e.target.value.split(":")[0];
                          setBatasJam(Number(hour));
                        }}
                      ></Form.Control>
                    </Form.Group>
                  </Form>
                </Card.Body>
                <Card.Footer>
                  <Button
                    onClick={() => {
                      tampilModal === "add"
                        ? createWaktuPatrol()
                        : editSkemaPatrol();
                    }}
                    className="btn-fill"
                    type="submit"
                    variant="info"
                  >
                    Submit
                  </Button>
                </Card.Footer>
              </Card>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default RegularTables;
